// extracted by mini-css-extract-plugin
export default {"page":"e1-z","cartModal":"f1-z","checkout":"g1-z","placeholder":"h1-z","account":"i1-z"};